import { Component, Input, Output, EventEmitter, Attribute } from '@angular/core';
import { map, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-nav-button',
    template: `
		<a href="javascript:void(0)"	(click)="OnClick()"
			[innerHTML]="symbol"
	  [attr.aria-label]="ariaLabel"
	  [attr.tabindex]="tabIndexValue"
			[class.circle]="showBackground"
			[class.disabled]="disabled"
			[style.width]="derivedSize" [style.height]="derivedSize"
			[style.borderRadius]="halfSize"
			[style.fontSize]="derivedSize"
			[style.color]="derivedIconColor"
			[style.backgroundColor]="derivedBackgroundColor"
		></a>
	`,
    styleUrls: ['./pageslider.component.scss']
})

export class NavButtonComponent {
    private isForward: boolean;
    
    constructor(
        @Attribute('forward') forward: any,
        @Attribute('backward') backward: any
    ){
        if (forward != undefined) {
            if (backward != undefined) {
                throw new Error("Nav Button cannot be both forward and backwards");
            } else {
                this.isForward = true;
            }
        } else if (backward != undefined) {
            this.isForward = false;
        } else {
            throw new Error("Must specify either 'forward' or 'backward' on nav button");
        }
    }


    // PUBLIC INTERFACE

    @Input() page : number;
    @Output() pageChange = new EventEmitter<number>();
    @Input() pageCount : number;

    @Input() size : number = 61;
    @Input() showBackground : boolean = false;
    @Input() iconColor : string;
    @Input() backgroundColor :  string = "transparent";


    // TEMPLATE FEATURES

    public get disabled() {
        if (this.isForward) {
            return this.page >= this.pageCount - 1;
        } else {
            return this.page <= 0;
        }
    }

    public get derivedIconColor() {
        if (this.iconColor !== undefined) return this.iconColor;
        return (this.showBackground) ? "black" : "white";
    }

    public get derivedBackgroundColor() {
        return (this.showBackground) ? this.backgroundColor : "none";
    }

    public get derivedSize() {return this.size + "px";}
    public get halfSize() {return this.size / 2 + "px";}

    public get symbol() {
        //	return (this.isForward) ? "&rsaquo;" : "&lsaquo;";
        return (this.isForward) ? '<i class="icon-right nav-right-icon"></i>' : '<i class="icon-left nav-left-icon"></i>';
    }
    public get ariaLabel() {
        //	return (this.isForward) ? "&rsaquo;" : "&lsaquo;";
        return (this.isForward) ? 'next' : 'previous';
    }
    public get tabIndexValue() {
        return (this.disabled) ? '-1' : '0';
    }

    public OnClick() {
        console.log(this.isForward);
        if (this.disabled) return;
        this.pageChange.emit((this.isForward) ? ++this.page : --this.page);
    }
}
